<template>
  <v-app style="background-color: #eceff1">
    <notifications group="gral_notif" position="bottom right" :width="400" />
    <v-app-bar color="blue-grey darken-3" app dark>
      <v-app-bar-nav-icon @click="drawer = !drawer"></v-app-bar-nav-icon>
      <!-- <v-spacer></v-spacer> -->
      <v-toolbar-title class="headline text-uppercase">
        <span>{{ appTitle }}</span>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <notificaciones-btn />
      <menu-preferencias @cambiarPass="cambiarPass = true" />
      <!-- <v-btn icon @click="cerrarSesion()">
                <v-icon>mdi-power</v-icon>
            </v-btn> -->
    </v-app-bar>
    <v-navigation-drawer
      v-model="drawer"
      color="blue-grey darken-3"
      :expand-on-hover="false"
      :mini-variant="false"
      :right="false"
      app
      dark
    >
      <left-menu :menu="menu" @cerrarMenu="drawer = false" />
    </v-navigation-drawer>

    <v-main>
      <main-content />
    </v-main>

    <main-footer />

    <cambiar-password
      v-if="cambiarPass"
      :mostrar="cambiarPass"
      @cancelar="cambiarPass = false"
    />
  </v-app>
</template>

<script>
import { mapGetters } from "vuex";
import axios from "axios";

import MenuPreferencias from "./menuPreferencias";
import NotificacionesBtn from "./notificaciones/notificacionesBtn";
import LeftMenu from "./leftMenu";
import MainContent from "./mainContent";
import MainFooter from "./mainFooter";
import CambiarPassword from "../usuarios/cambiarPassword";

export default {
  components: {
    MenuPreferencias,
    NotificacionesBtn,
    LeftMenu,
    MainContent,
    MainFooter,
    CambiarPassword,
  },
  computed: {
    ...mapGetters([
      "httpURL",
      "sessionToken",
      "role",
      "blockNotificaciones",
      "appTitle",
    ]),
  },
  created() {
    if (sessionStorage.getItem("token"))
      this.$store.dispatch("setSessionToken", sessionStorage.getItem("token"));
    if (localStorage.getItem("token"))
      this.$store.dispatch("setSessionToken", localStorage.getItem("token"));
    if (!this.sessionToken) this.$router.push("/login");
    axios
      .get(this.httpURL + "/login", { headers: { token: this.sessionToken } })
      .then((res) => {
        // console.log(res.data);
        if (res.data.ok) {
          this.$store.dispatch("setMaster", res.data.master);
          this.$store.dispatch("setUserName", res.data.nombre);
          this.$store.dispatch("setUserNameComplete", res.data.nombreC);
          // this.$store.dispatch("setPermisos", res.data.permisos);
          this.$store.dispatch("setRole", res.data.role);
          this.$store.dispatch("setUserId", res.data.id);
          this.$store.dispatch("setUserCodigo", res.data.codigo);
          this.$store.dispatch(
            "setBlockNotificaciones",
            res.data.blockNotificaciones
          );
          this.$store.dispatch("setUserCorreo", res.data.correo);
          this.menu = this.menu.concat(res.data.menu);
          if (res.data.role == "centro") this.$router.push("/centros");
        //   this.$socket.emit("usuarioAutenticado", { id: res.data.id });
        } else {
          localStorage.removeItem("token");
          sessionStorage.removeItem("token");
          this.$router.push("/login");
        }
      })
      .catch((error) => {
        // console.log('Error: '+error);
        localStorage.removeItem("token");
        sessionStorage.removeItem("token");
        if(error.response)this.$router.push('/login');
      });
  },
  data: () => ({
    drawer: false,
    loading: false,
    menu: [],
    cambiarPass: false,
  }),
  methods: {
    cerrarSesion() {
      localStorage.removeItem("token");
      sessionStorage.removeItem("token");
      this.$store.dispatch("setSessionToken", null);
      this.$router.push("/login");
    },
  },
};
</script>